import { Component, NgModule, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ImageSliderComponentModule } from '@component/generic/image-slider/image-slider.component';
import { SliderComponentModule } from '@component/slider/slider.component';
import { environment } from '@environments/environment';
import { MobileService } from '@service/mobile.service';
import { PartnerService } from '@service/partner.service';
import { SliderImagesService } from '@service/slider-images.service';
import { StateService } from '@service/state.service';
import { SharedModule } from 'src/app/shared.module';

@Component({
  selector: 'app-partner',
  templateUrl: './partner.component.html',
  styleUrls: ['./partner.component.scss']
})
export class PartnerComponent implements OnInit {

  public environment = environment

  public sliderItems = []

  public hasSliderImages: boolean = false;

  constructor(
    public PartnerService: PartnerService,
    public mobileService: MobileService,
    public StateService: StateService,
    public sliderImagesService: SliderImagesService,
  ) { }

  ngOnInit() {

    this.PartnerService.getPartnerlogos()
      .then(partnerlogos => {
        this.sliderItems = partnerlogos
      })

    this.sliderImagesService.hasSliderImages$.subscribe((hasImages: boolean) => {
      this.hasSliderImages = hasImages;
    })

    this.sliderImagesService.checkHasSliderImages('partners');
  }

  public gotoContact() {
    this.StateService.goto('/peripherals/contact')
  }
}

@NgModule({
  declarations: [
    PartnerComponent
  ],
  imports: [
    SharedModule,
    RouterModule.forChild([
      {
        path: "",
        data: {
          title: 'Unsere Partner | Zimmerer-Treffpunkt',
        },
        component: PartnerComponent
      },
    ]),

    SliderComponentModule,
    ImageSliderComponentModule
  ],
  exports: [
    PartnerComponent,

    SharedModule,
    SliderComponentModule,
    ImageSliderComponentModule
  ]
})
export class PartnerComponentModule { }